import { styled } from '@mui/material/styles';
import MuiCardHeader from '@mui/material/CardHeader';
import MuiCardContent from '@mui/material/CardContent';

const CardContent = styled(MuiCardContent)(({ theme }) => ({
    padding: theme.spacing(3, 4),
}));

const CardHeader = styled(MuiCardHeader)(({ theme }) => ({
    padding: theme.spacing(2, 4),
}));

export { CardContent, CardHeader };
